import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import {
	type ModuleIdType,
	type BusinessObjectIdType,
	type UserIdType,
	UserIdCtor,
} from '../types.js'
import {
	jsonProperty,
	jsonArrayProperty,
	jsonClass,
} from '@sumbricht/json-class-serializer'
import { User } from './user.js'

@jsonClass('UserConfiguration')
export class UserConfiguration {
	@jsonProperty(Number)
	id?: number

	@jsonProperty(() => UserIdCtor)
	userId?: UserIdType
	user?: User

	@jsonProperty(String)
	configModuleId: ModuleIdType = ''

	@jsonProperty(String)
	configBoId: BusinessObjectIdType = ''

	@jsonProperty(String)
	valueJson: string = ''

	constructor(init?: Partial<UserConfiguration>) {
		assignCommonProperties(this, init)
	}

	getQualifiedName() {
		return `${this.configModuleId}.${this.configBoId}`
	}
}
